import {Injectable} from '@angular/core';
import {PageEvent as NgPageEvent} from '@angular/material/paginator';
import { IListing } from 'src/app/interfaces/listing';
import { IListingFilter } from 'src/app/interfaces/listing-filter';
import { ApiDataSource } from 'src/app/services/api-data-source.service';
import {BehaviorSubject} from 'rxjs';

import {ListingApiService} from './listing-api-service';
import { IResponseBody } from 'src/app/interfaces/response-body';

export class ListingDataSource extends ApiDataSource {
  constructor(
    protected ListingApi: ListingApiService,
    private readonly role: string,
    private readonly ListingFilter?: IListingFilter
  ) {
    super();
    !!this.ListingFilter &&
      Object.keys(this.ListingFilter).forEach(key =>
        this.setFilter(key, this.ListingFilter[key])
      );
  }

  protected Data: BehaviorSubject<IListing[]> = new BehaviorSubject([]);

  private Listings: IListing[] = null;
  private feature: string = null;

  protected loadData(PageEvent: NgPageEvent) {
    return this.ListingApi.listWithPageEvent(
      this.role,
      this.filter.value,
      PageEvent
    );
  }

  protected setData(ResponseBody: IResponseBody) {
    this.Listings = ResponseBody.data;
    this.setListings();
  }

  public setFeature(feature?: string) {
    this.feature = feature;
    this.setListings();
  }

  public read(id: number) {
    return this.ListingApi.read(this.role, id);
  }

  public save(Listing: IListing) {
    return this.ListingApi.save(this.role, Listing, this.filter.value);
  }

  public duplicate(Listing: IListing) {
    return this.ListingApi.duplicate(this.role, Listing);
  }

  public enable(Listing: IListing, enabled: boolean) {
    return this.ListingApi.enable(this.role, Listing, enabled).then(result => {
      this.loadWithPageEvent();
      return result;
    });
  }

  public delete(Listing: IListing) {
    return this.ListingApi.delete(this.role, Listing).then(result => {
      this.loadWithPageEvent();
      return result;
    });
  }

  public readAuditLog(id: number) {
    return this.ListingApi.readAuditLog(this.role, id);
  }

  protected setListings() {
    const Listings = this.feature
      ? this.getListingsWithFeature()
      : this.Listings;

    this.Data.next(Listings);
  }

  private getListingsWithFeature(): IListing[] {
    return !this.feature
      ? this.Listings
      : this.Listings.filter((Listing: IListing) => {
          return (
            !!Listing.features && Listing.features.hasOwnProperty(this.feature)
          );
        });
  }
}
